/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Input, NgZone, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {safeDetectChanges} from '../common/util/safe-detect-changes';

@Component({
  standalone: false,
  selector: 'adn-external-ad-unit-analysis-page',
  template: `
    <p *ngIf="effectiveIsNew" class="alert alertSimple small">
      This space will be filled with charts once the external ad unit is saved.
    </p>
    <ng-container *ngIf="!effectiveIsNew">
      <div class="analysisWidgetContainer">
        <adn-performance-chart [obj]="model" adnChartType="EXTERNAL_AD_UNIT"></adn-performance-chart>
      </div>

      <div class="topStatsWidgetContainer chartOptions">
        <adn-top-stats-table [object]="model" parentType="ExternalAdUnit" childType="Site"></adn-top-stats-table>
      </div>

      <div class="topStatsWidgetContainer chartOptions">
        <adn-top-stats-table [object]="model" parentType="ExternalAdUnit" childType="AdUnit"></adn-top-stats-table>
      </div>

      <div class="analysisWidgetContainer analysisReportWidgets">
        <adn-notes [object]="model" [saveObject]="model"></adn-notes>
      </div>
    </ng-container>
  `
})
export class ExternalAdUnitAnalysisPageComponent implements OnChanges, OnDestroy {
  @Input() model: any;
  @Input() modelComms: any;
  @Input() isNew: boolean;

  effectiveIsNew = false;

  private subscribedModelComms: any;
  private destroyed = false;

  constructor(
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isNew) {
      this.effectiveIsNew = !!this.isNew;
    }
    if (changes.modelComms) {
      this.subscribeModelComms();
    }
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  private subscribeModelComms(): void {
    if (!this.modelComms || this.subscribedModelComms === this.modelComms) {
      return;
    }
    this.subscribedModelComms = this.modelComms;
    // Route isNew never flips after save; modelComms does.
    this.modelComms.addSubscriber((data: any, type: any, isNewFromComms?: boolean) => {
      if (this.destroyed || type) {
        return;
      }
      this.ngZone.run(() => {
        if (isNewFromComms === true || isNewFromComms === false) {
          this.effectiveIsNew = isNewFromComms;
        } else if (data?.name) {
          this.effectiveIsNew = false;
        }
        if (data?.name && this.model) {
          this.model.name = data.name;
        }
        safeDetectChanges(this.cdr);
      });
    });
  }
}
